package net.sergeych.ugdx.shared

import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Suppress("unused")
enum class OperationType {
    IMPORT, EXPORT, TRANSFER, COMMISSION, REFUND, REWARD;
}

@Serializable
data class ApiOperation(
    val id: Long,
    val fromAccountId: Long?,
    val toAccountId: Long?,
    val type: OperationType,
    val purpose: String,
    val orderId: Long?,
    val referredOperationId: Long?,
    val createdAt: Instant,
    val fromLoginName: String?=null,
    val toLoginName: String?=null,
)
